import { Add } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';

type AddBranchCardProps = {
  onClick: () => void;
};

export const AddBranchCard = ({ onClick }: AddBranchCardProps) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        height: '100%',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: `2px dashed ${alpha(theme.palette.divider, 0.3)}`,
        borderRadius: 2,
        background: theme.palette.background.default,
        boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.08)}`,
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
          borderColor: theme.palette.primary.main,
          borderWidth: 2,
          boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`,
          backgroundColor: alpha(theme.palette.primary.main, 0.02),
          '& .add-icon': {
            transform: 'scale(1.1)',
            color: theme.palette.primary.main,
          },
          '& .add-text': {
            color: theme.palette.primary.main,
          },
        },
      }}
      onClick={onClick}
    >
      <CardContent
        sx={{
          p: 2,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          pb: '5px!important',
        }}
      >
        <Box
          className="add-icon"
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            background: alpha(theme.palette.primary.main, 0.08),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1.5,
            transition: 'all 0.2s ease',
            border: `2px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        >
          <Add
            sx={{
              fontSize: 24,
              color: theme.palette.text.secondary,
              transition: 'all 0.2s ease',
            }}
          />
        </Box>
        <Typography
          className="add-text"
          variant="h6"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            fontSize: '1rem',
            mb: 0.25,
            transition: 'all 0.2s ease',
          }}
        >
          Yeni Şube Ekle
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: '0.7rem',
          }}
        >
          Yeni bir şube oluşturun
        </Typography>
      </CardContent>
    </Card>
  );
};
